import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	width: 100%;
	padding-top: 3em;

	.cols {
		display: flex;
		align-items: flex-start;
		justify-content: center;

		.col-left {
			width: 50%;
			border-right: 0.1em solid #000;
			padding: 3em;
		}

		.col-right {
			width: 50%;
			padding: 3em;

			.helper {
				padding-top: 1em;
				font-size: 0.8em;
				text-align: center;
			}
		}
	}
	.section {
		.headline {
			font-size: 1.1em;
			font-weight: 700;
			text-align: left;
			padding-bottom: 1em;
		}

		.button-mobile-wrapper {
			display: none;
			align-items: center;
			justify-content: center;
		}

		.layout-forms-input-row {
			.layout-forms-input {
				.layout-forms-input-wrapper {
					.internal-wrapper {
						.input-decorator {
							text-decoration: none;

							&:hover {
								text-decoration: underline;
							}
						}
					}
				}
			}
		}

		.layout-button-group {
			margin-top: 1.5em;
			width: 70%;

			.layout-button {
				.button {
					padding: 1em;
				}
			}
		}

		.phone-container {
			flex-direction: column;

			.phone {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				gap: 1em;

				.layout-forms-input {
					position: relative;
				}

				.name-phonePrefix {
					padding-top: 1em;
					width: 25%;
				}

				.name-phone {
					width: 70%;
				}
			}
		}
	}
	.google-recaptcha {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 2em;
	}

	@media all and (max-width: ${vars.tabletS}) {

        background-color: ${vars.colorBackgroundContrastDark};
        padding: 0 2em 8em 2em;
        margin: 0;

		.cols {
			flex-direction: column;
			justify-content: flex-start;

			.col-left {
				width: 100%;
				border-right: none;
				padding: 1em 1em 0;
			}

			.col-right {
				width: 100%;
				padding: 0 1em 1em;
				margin-top: -2em;
			}
		}

		.section {
			padding-bottom: 2em;

			.headline {
				display: none;
			}

			.control {
				padding-bottom: 1.2em;
                padding: 0;
                margin: 0;

				.button-mobile-wrapper {
					display: block;
                    padding: 0;
                    margin: 0;
                    width: 100%;

					.mobile-links {
						display: flex;
						justify-content: center;
						align-items: center;
						padding: 0;
						margin: 0;

						.links {
							display: flex;
							min-width: 100%;
							margin-bottom: 2em;

							.links-page {
								padding: 0.7em 2em;
								font-size: 1.1em;
								width: 50%;
								border-radius: 0.3em;
								color: ${vars.colorText};
								display: flex;
								justify-content: center;
								align-items: center;
								text-decoration: none;
							}
							.login-page {
								border: 0.09em solid ${vars.colorBorder};
							}
							.link-register {
								transform: translate(-2%);
								background-color: ${vars.colorElement};
								border: 0.09em solid ${vars.colorElement};
							}
						}
					}

					.helper {
						font-size: 0.8em;
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.mobileM}) {
	}
`;
